import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import withTimeout from '@/utils/async/withTimeout';

type GetRemoteSettingsParams<T> = {
  name: string;
  tag?: string;
  timeout?: number;
  validate?: (settings: unknown) => boolean;
  defaultValue: T;
};

const getRemoteSettings = async <T>({
  name,
  tag,
  timeout = 3000,
  validate = () => true,
  defaultValue,
}: GetRemoteSettingsParams<T>): Promise<T> => {
  try {
    const remoteSettingsPromise = getContext().handlers.getRemoteSettings<T>(
      name,
      tag
    );
    const remoteSettings = await withTimeout({
      promise: remoteSettingsPromise,
      timeoutMs: timeout,
    });

    if (validate(remoteSettings)) {
      errorLogger.trigger(
        `Remote settings for ${name} received successfully`,
        BUGSNAG_STATUSES.INFO
      );
      return remoteSettings;
    }
    errorLogger.trigger(
      'Invalid remote settings received',
      BUGSNAG_STATUSES.WARN
    );
    return defaultValue;
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.ERROR);
    return defaultValue;
  }
};

export default getRemoteSettings;
